import { getUtmQueryString } from "@escapio/portal/state/utm";
import { getVersion } from "@escapio/portal/dom/screen";
import { getExperimentVersionsAsJSONString } from "@escapio/portal/experiments/info";
import { travelData } from "@escapio/portal/state/travelData";

export function formatBookingRedirectUrl(endpoint, token, origin) {
	const parameters = {
		token,
		origin,
		utm: getUtmQueryString(),
		device: getVersion(),
		experiments: getExperimentVersionsAsJSONString(),
		...travelData.formattedRequestParameter,
	};

	const url = new URL(endpoint);
	Object.entries(parameters).forEach(([parameterKey, parameterValue]) =>
		url.searchParams.set(parameterKey, parameterValue.toString()),
	);
	return url;
}
